import React from "react";
import { Link } from "react-router-dom";

import Sunset from "../components/Sunset";

import "../styles/Gallery.css";

import posterArt from "../images/gallery/poster-art.jpg";
import performance from "../images/gallery/performance.jpg";

const Gallery = () => {
    return (
        <div>
            <Sunset />
            <div className="mt-5 image-container">
                <Link to="/gallery/posters" style={{ textDecoration: "none" }}>
                    <img
                        src={posterArt}
                        alt="Poster Art"
                        className="responsive-poster"
                    />
                </Link>
                <Link to="/gallery/photos" style={{ textDecoration: "none" }}>
                    <img
                        src={performance}
                        alt="Performance Photos"
                        className="responsive-photo"
                    />
                </Link>
            </div>
        </div>
    );
};

export default Gallery;



// WEBPACK FOOTER //
// ./src/components/Gallery.js